import { Injectable } from '@angular/core';

@Injectable()
export class DataService {
    private data: any;
    constructor() { }
    public set graphData(data: any) {
        this.data = data;
    }

    public get graphData() {
        return this.data;
    }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/dashboard/graph/pie-chart/data.service.ts